// Device State
import { DeviceIdentityModel, DeviceTwinModel, DirectMethodResponse, C2DSendResponse, TelemetryMessage } from '../../services/device.service';

export interface DeviceState {
  deviceId: string | null;
  identity: DeviceIdentityModel | null;
  twin: DeviceTwinModel | null;
  connectionState: 'Connected' | 'Disconnected' | null;
  loading: boolean;
  error: string | null;
  
  // Direct Method
  directMethodResult: DirectMethodResponse | null;
  directMethodLoading: boolean;
  directMethodError: string | null;
  
  // Cloud to Device
  c2dResult: C2DSendResponse | null;
  c2dSending: boolean;
  c2dError: string | null;
  
  // Telemetry
  telemetryMessages: TelemetryMessage[];
  telemetryLoading: boolean;
  telemetryError: string | null;
}

export const initialDeviceState: DeviceState = {
  deviceId: null,
  identity: null,
  twin: null,
  connectionState: null,
  loading: false,
  error: null,
  
  directMethodResult: null,
  directMethodLoading: false,
  directMethodError: null,
  
  c2dResult: null,
  c2dSending: false,
  c2dError: null,
  
  telemetryMessages: [],
  telemetryLoading: false,
  telemetryError: null,
};
